export const ProjectFilterOptions = [
  {
    filterName: 'Tech',
    options: ['React', 'Node.js', 'Mongo DB', 'SQL', 'HTML', 'CSS'],
  },
  {
    filterName: 'Uploaded',
    options: [1, 2, 3, 4],
  },
];
